export default "__VITE_ASSET__BCmFD2H8__"